// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LTX takes its colours from the header's violet-to-crimson wash. The paper
   stays cream -- the squares are cream here too -- and the accent moves off
   burnt orange, which sat badly next to the purple. See
   assets/css/BingoCard.css for what each name means. */
:root {
  --wsb-accent: #7b2a6b;
  --wsb-accent-ink: #ffffff;

  --wsb-bar-bg: linear-gradient(45deg, #5b0a65, #9b0a33);
  --wsb-bar-ink-muted: #f0d4ec;
  --wsb-bar-glint: #f3c9e8;
  --wsb-badge-ink: #6b0a4a;

  --wsb-ink-muted: #5f4a5c;
  --wsb-line: rgba(91, 10, 101, 0.28);
  --wsb-line-strong: rgba(91, 10, 101, 0.55);

  --wsb-accent-text: #7a1052;
  --wsb-chip-line: rgba(122, 16, 82, 0.45);

  --wsb-onbrand-line: rgba(243, 201, 232, 0.35);
  --wsb-snap-ring: rgba(243, 201, 232, 0.85);

  --wsb-toast-bg: rgba(123, 42, 107, 0.85);
  --wsb-toast-bg-idle: rgba(155, 10, 51, 0.8);

  --wsb-verified-glow-soft: rgba(243, 160, 226, 0.2);
  --wsb-verified-glow-strong: rgba(243, 160, 226, 0.55);
}

body {
  background-color: #555;
  z-index: -1;
}

/* Reset and base styles */
* {
  font-family: 'Helvetica', sans-serif;
  padding: 0;
  margin: 0;
}

#back-img {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  /* background-color: #000; */
  /* background-image: linear-gradient(to bottom, #6699ff, #ff66cc); */
  background-image: url("https://wanshow.bingo/resources/images/background2.jpeg");
  background-size: cover;
  background-position: center;
  z-index: -2;
  opacity: 0.2;
  overflow: hidden;
}

.user-count {
  animation: typing 0.5s steps(20, end);
}

nav {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  background-color: #333;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  padding: 0 20px;
}

.nav-logo img {
  height: 40px;
}

.nav-links a {
  color: white;
  text-decoration: none;
  margin: 0 10px;
  font-size: 18px;
}

.nav-login a {
  color: white;
  text-decoration: none;
  font-size: 18px;
}

@keyframes typing {
  from {
    width: 0;
  }
}

#bodyWrapper {
  width: 1000px;
  display: block;
  margin: 0px auto;
  padding-top: 50px;
  padding-bottom: 50px;
}

#game {
  /* width: 100%; */ /* removed: overflowed its container and broke centring — every other theme inherits the base 1000px card */
  display: inline-block;
  background-image: linear-gradient(to bottom, #40046559, #9b0a334c);
  padding: 15px 10px;
  text-align: center;
  color: white;
  font-size: 14pt;
  border-radius: 20px;
  box-shadow: 10px 10px 12px -15px black;
}

#game p {
  line-height: 30px;
}

#game a {
  color: white;
}

.hidden {
  display: none;
}

.board {
  width: 1000px;
  margin: auto;
  display: block;
}

#board {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative; /* Added to position the background image */
  z-index: 1; /* Added to stack the game board above the background image */
  flex-wrap: wrap; /* Allow items to wrap onto the next line */
  transform-origin: top left; /* Scale from the top left corner */
}

#board::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("https://wanshow.bingo/resources/images/backgroundltx.png");
  background-size: cover;
  background-position: center;
  background-attachment: fixed; /* Changed to fixed to keep the background image in place */
  z-index: -1; /* Stack the background image below the grid items */
}

.item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% / 5 - 10px); /* adjust the denominator based on how many items you want in a row */
  vertical-align: middle;
  text-align: center;
  width: 178px;
  height: 153px;
  border: 1px #c13e05 solid;
  background-image: url("https://wanshow.bingo/resources/images/paper.png");
  float: left;
  color: black;
  padding: 10px;
}

.item p {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.title {
  width: 100%;
  text-align: center;
  margin-top: 15px;
  font-size: 32pt;
}

.clicked {
  background: linear-gradient(to right, #b5226279, #893f8e78);
  color: white;
  border-color: #f0dddd;
  animation: borderColorChange 2s infinite;
}

@keyframes borderColorChange {
  0% {
    border-color: #FF0000;
  }
  16.67% {
    border-color: #FF6A00;
  }
  33.33% {
    border-color: #FFD800;
  }
  50% {
    border-color: #00FF00;
  }
  66.67% {
    border-color: #0000FF;
  }
  83.33% {
    border-color: #4B0082;
  }
  100% {
    border-color: #9400D3;
  }
}

.footer {
  padding: 1rem 0;
  width: 100%;
  /* position: absolute; */
  bottom: 0;
}

.footer-container {
  display: flex;
  justify-content: space-around;
  width: 100%;
  align-items: center;
  flex-wrap: wrap;
}

.footer-links {
  display: flex;
  align-items: center;
}

.footer-links a {
  color: #f2f2f2;
  text-decoration: none;
  margin-right: 1rem;
}

.footer-links a:hover {
  color: #e0e0e0;
}

/* Remove underline from footer & a href */
.footer-links a:hover {
  text-decoration: none;
}

.footer-copyright {
  color: #f2f2f2;
  font-size: 0.9rem;
}

a {
  color: white;
}

a:hover {
  color: #ff6600;
}

#team {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.section {
  flex: 0 0 48%; /* Each section will take up 48% of the available space */
  margin: 10px;
  /* Add media query to stack sections vertically on smaller screens */
}

.discord-banner {
  display: flex;
  align-items: center;
  background-color: #5865F2; /* Discord's blurple color from the color palette */
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  margin-top: 10px;
  width: -moz-fit-content;
  width: fit-content;
}

.discord-icon {
  font-size: 18px;
  margin-right: 5px;
}

.discord-tag {
  font-size: 14px;
}

.member {
  /* width: calc(50% - 20px); */
  margin: 10px;
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
}

.member img {
  width: 150px;
  border-radius: 50%;
}

.member h2 {
  font-size: 24px;
  margin-top: 10px;
}

.member p {
  margin-top: 5px;
}

.member .social-links {
  margin-top: 10px;
}

.member .social-links a {
  color: #555;
  text-decoration: none;
  margin-right: 10px;
  font-size: 18px;
}

.member .social-links a:hover {
  color: #ff6600;
}

.countdown-box.svelte-1xheok0 {
  min-width: 23em;
  margin: 0 auto;
  font-family: "Dosis", sans-serif;
  background-color: #c13e05;
  padding: 15px 10px;
  text-align: center;
  color: white;
  font-size: 14pt;
  border-radius: 20px;
  box-shadow: 10px 10px 12px -15px black;
}

.countdown-box.svelte-1xheok0 {
  width: auto; /* Adjust to content */
  max-width: 550px;
  margin: 20px auto; /* Center the box */
  font-family: 'Dosis', sans-serif;
  background-color: #c13e05; /* LTT orange */
  padding: 15px 20px; /* Increased padding */
  text-align: center;
  color: white;
  font-size: 14pt;
  border-radius: 20px;
  box-shadow: 10px 10px 12px -15px black;
  white-space: nowrap; /* Prevents the text from wrapping */
}

.provider-text {
  font-size: 10pt;
  text-align: right;
  color: #ffffff;
}

#wan-show-timer a {
  text-decoration: none;
  color: inherit;
  display: block; /* Make the entire area clickable */
}

.discord-banner {
  display: flex;
  align-items: center;
  background-color: #5865F2; /* Discord's blurple color from the color palette */
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  margin-top: 10px;
  width: -moz-fit-content;
  width: fit-content;
}

.discord-icon {
  font-size: 18px;
  margin-right: 5px;
}

.discord-tag {
  font-size: 14px;
}

.discord-tag {
  background-color: #5865F2; /* Discord's purple color from the color palette */
  padding: 5px 10px;
  border-radius: 15px;
  display: inline-block;
}

.discord-banner::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% + 10px);
  height: calc(100% + 10px);
  border-radius: 20px;
  z-index: -1;
}

.member {
  margin-bottom: 20px;
}

.section h2 {
  color: white;
}

@media (max-width: 768px) {
  .section {
    flex: 0 0 100%; /* On smaller screens, each section takes up 100% of the available space */
  }
}

@media (max-width: 768px) {
  .member {
    width: calc(50% - 18px);
  }
}

@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    text-align: center;
  }

  .footer-links {
    margin-bottom: 0.5rem;
  }
}

@media (max-width: 3840px) {
  #game {
    /* transform: scale(1.2); */  /* use the base scale ladder */ /* Scale down to 90% on smaller screens */
    /* transform-origin: center; */  /* use the base scale ladder */ /* Added to scale from the center */
  }

  #nav-container {
    transform: scale(0.8); /* Scale down to 80% on even smaller screens */
    transform-origin: center; /* Added to scale from the center */
  }
}

@media (max-width: 1920px) {
  #game {
    /* transform: scale(1.0); */  /* use the base scale ladder */ /* Scale down to 90% on smaller screens */
    /* transform-origin: center; */  /* use the base scale ladder */ /* Added to scale from the center */
    padding-left: 10px;
  }

  #nav-container {
    transform: scale(1.0); /* Scale down to 80% on even smaller screens */
    transform-origin: center; /* Added to scale from the center */
  }
}

@media (max-width: 1200px) {
  #game {
    /* transform: scale(0.9); */  /* use the base scale ladder */ /* Scale down to 90% on smaller screens */
    /* transform-origin: center; */  /* use the base scale ladder */ /* Added to scale from the center */
    padding-left: 10px;
  }

  #nav-container {
    transform: scale(0.9); /* Scale down to 80% on even smaller screens */
    transform-origin: center; /* Added to scale from the center */
  }
}

@media (max-width: 768px) {
  #game {
    /* transform: scale(0.84); */  /* use the base scale ladder */ /* Scale down to 80% on even smaller screens */
    /* transform-origin: center; */  /* use the base scale ladder */ /* Added to scale from the center */
    padding-left: 10px;
  }

  #nav-container {
    transform: scale(0.84); /* Scale down to 80% on even smaller screens */
    transform-origin: center; /* Added to scale from the center */
  }
}

@media (max-width: 480px) {
  #game {
    /* transform: scale(0.65); */  /* use the base scale ladder */ /* Scale down to 70% on the smallest screens */
    /* transform-origin: center; */  /* use the base scale ladder */ /* Added to scale from the center */
    padding-left: 10px;
  }

  #nav-container {
    transform: scale(0.65); /* Scale down to 80% on even smaller screens */
    transform-origin: center; /* Added to scale from the center */
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/BingoCard-LTX23.css"],"names":[],"mappings":"AAAA;;;uDAGuD;AACvD;EACE,qBAAqB;EACrB,yBAAyB;;EAEzB,sDAAsD;EACtD,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;;EAExB,wBAAwB;EACxB,mCAAmC;EACnC,0CAA0C;;EAE1C,0BAA0B;EAC1B,wCAAwC;;EAExC,6CAA6C;EAC7C,0CAA0C;;EAE1C,wCAAwC;EACxC,2CAA2C;;EAE3C,kDAAkD;EAClD,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,oEAAoE;EACpE,gFAAgF;EAChF,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE;IACE,QAAQ;EACV;AACF;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB,EAAE,2GAA2G;EAC9H,qBAAqB;EACrB,kEAAkE;EAClE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,kBAAkB,EAAE,2CAA2C;EAC/D,UAAU,EAAE,6DAA6D;EACzE,eAAe,EAAE,2CAA2C;EAC5D,0BAA0B,EAAE,mCAAmC;AACjE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iFAAiF;EACjF,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B,EAAE,2DAA2D;EACzF,WAAW,EAAE,oDAAoD;AACnE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B,EAAE,qEAAqE;EACnG,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,yEAAyE;EACzE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2DAA2D;EAC3D,YAAY;EACZ,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa,EAAE,yDAAyD;EACxE,YAAY;EACZ,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB,EAAE,mDAAmD;EAC9E,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,WAAW,EAAE,sBAAsB;EACnC,gBAAgB;EAChB,iBAAiB,EAAE,mBAAmB;EACtC,gCAAgC;EAChC,yBAAyB,EAAE,eAAe;EAC1C,kBAAkB,EAAE,sBAAsB;EAC1C,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB,EAAE,oCAAoC;AAC3D;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc,EAAE,mCAAmC;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB,EAAE,mDAAmD;EAC9E,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,kDAAkD;EAC7E,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,cAAc,EAAE,0EAA0E;EAC5F;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,2BAA2B,GAAG,8BAA8B,EAAE,yCAAyC;IACvG,8BAA8B,GAAG,8BAA8B,EAAE,mCAAmC;EACtG;;EAEA;IACE,qBAAqB,EAAE,8CAA8C;IACrE,wBAAwB,EAAE,mCAAmC;EAC/D;AACF;;AAEA;EACE;IACE,2BAA2B,GAAG,8BAA8B,EAAE,yCAAyC;IACvG,8BAA8B,GAAG,8BAA8B,EAAE,mCAAmC;IACpG,kBAAkB;EACpB;;EAEA;IACE,qBAAqB,EAAE,8CAA8C;IACrE,wBAAwB,EAAE,mCAAmC;EAC/D;AACF;;AAEA;EACE;IACE,2BAA2B,GAAG,8BAA8B,EAAE,yCAAyC;IACvG,8BAA8B,GAAG,8BAA8B,EAAE,mCAAmC;IACpG,kBAAkB;EACpB;;EAEA;IACE,qBAAqB,EAAE,8CAA8C;IACrE,wBAAwB,EAAE,mCAAmC;EAC/D;AACF;;AAEA;EACE;IACE,4BAA4B,GAAG,8BAA8B,EAAE,8CAA8C;IAC7G,8BAA8B,GAAG,8BAA8B,EAAE,mCAAmC;IACpG,kBAAkB;EACpB;;EAEA;IACE,sBAAsB,EAAE,8CAA8C;IACtE,wBAAwB,EAAE,mCAAmC;EAC/D;AACF;;AAEA;EACE;IACE,4BAA4B,GAAG,8BAA8B,EAAE,8CAA8C;IAC7G,8BAA8B,GAAG,8BAA8B,EAAE,mCAAmC;IACpG,kBAAkB;EACpB;;EAEA;IACE,sBAAsB,EAAE,8CAA8C;IACtE,wBAAwB,EAAE,mCAAmC;EAC/D;AACF","sourcesContent":["/* LTX takes its colours from the header's violet-to-crimson wash. The paper\n   stays cream -- the squares are cream here too -- and the accent moves off\n   burnt orange, which sat badly next to the purple. See\n   assets/css/BingoCard.css for what each name means. */\n:root {\n  --wsb-accent: #7b2a6b;\n  --wsb-accent-ink: #ffffff;\n\n  --wsb-bar-bg: linear-gradient(45deg, #5b0a65, #9b0a33);\n  --wsb-bar-ink-muted: #f0d4ec;\n  --wsb-bar-glint: #f3c9e8;\n  --wsb-badge-ink: #6b0a4a;\n\n  --wsb-ink-muted: #5f4a5c;\n  --wsb-line: rgba(91, 10, 101, 0.28);\n  --wsb-line-strong: rgba(91, 10, 101, 0.55);\n\n  --wsb-accent-text: #7a1052;\n  --wsb-chip-line: rgba(122, 16, 82, 0.45);\n\n  --wsb-onbrand-line: rgba(243, 201, 232, 0.35);\n  --wsb-snap-ring: rgba(243, 201, 232, 0.85);\n\n  --wsb-toast-bg: rgba(123, 42, 107, 0.85);\n  --wsb-toast-bg-idle: rgba(155, 10, 51, 0.8);\n\n  --wsb-verified-glow-soft: rgba(243, 160, 226, 0.2);\n  --wsb-verified-glow-strong: rgba(243, 160, 226, 0.55);\n}\n\nbody {\n  background-color: #555;\n  z-index: -1;\n}\n\n/* Reset and base styles */\n* {\n  font-family: 'Helvetica', sans-serif;\n  padding: 0;\n  margin: 0;\n}\n\n#back-img {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  /* background-color: #000; */\n  /* background-image: linear-gradient(to bottom, #6699ff, #ff66cc); */\n  background-image: url(\"https://wanshow.bingo/resources/images/background2.jpeg\");\n  background-size: cover;\n  background-position: center;\n  z-index: -2;\n  opacity: 0.2;\n  overflow: hidden;\n}\n\n.user-count {\n  animation: typing 0.5s steps(20, end);\n}\n\nnav {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  background-color: #333;\n}\n\n.nav-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  max-width: 1200px;\n  padding: 0 20px;\n}\n\n.nav-logo img {\n  height: 40px;\n}\n\n.nav-links a {\n  color: white;\n  text-decoration: none;\n  margin: 0 10px;\n  font-size: 18px;\n}\n\n.nav-login a {\n  color: white;\n  text-decoration: none;\n  font-size: 18px;\n}\n\n@keyframes typing {\n  from {\n    width: 0;\n  }\n}\n\n#bodyWrapper {\n  width: 1000px;\n  display: block;\n  margin: 0px auto;\n  padding-top: 50px;\n  padding-bottom: 50px;\n}\n\n#game {\n  /* width: 100%; */ /* removed: overflowed its container and broke centring — every other theme inherits the base 1000px card */\n  display: inline-block;\n  background-image: linear-gradient(to bottom, #40046559, #9b0a334c);\n  padding: 15px 10px;\n  text-align: center;\n  color: white;\n  font-size: 14pt;\n  border-radius: 20px;\n  box-shadow: 10px 10px 12px -15px black;\n}\n\n#game p {\n  line-height: 30px;\n}\n\n#game a {\n  color: white;\n}\n\n.hidden {\n  display: none;\n}\n\n.board {\n  width: 1000px;\n  margin: auto;\n  display: block;\n}\n\n#board {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  position: relative; /* Added to position the background image */\n  z-index: 1; /* Added to stack the game board above the background image */\n  flex-wrap: wrap; /* Allow items to wrap onto the next line */\n  transform-origin: top left; /* Scale from the top left corner */\n}\n\n#board::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-image: url(\"https://wanshow.bingo/resources/images/backgroundltx.png\");\n  background-size: cover;\n  background-position: center;\n  background-attachment: fixed; /* Changed to fixed to keep the background image in place */\n  z-index: -1; /* Stack the background image below the grid items */\n}\n\n.item {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: calc(100% / 5 - 10px); /* adjust the denominator based on how many items you want in a row */\n  vertical-align: middle;\n  text-align: center;\n  width: 178px;\n  height: 153px;\n  border: 1px #c13e05 solid;\n  background-image: url(\"https://wanshow.bingo/resources/images/paper.png\");\n  float: left;\n  color: black;\n  padding: 10px;\n}\n\n.item p {\n  display: table-cell;\n  vertical-align: middle;\n  text-align: center;\n}\n\n.title {\n  width: 100%;\n  text-align: center;\n  margin-top: 15px;\n  font-size: 32pt;\n}\n\n.clicked {\n  background: linear-gradient(to right, #b5226279, #893f8e78);\n  color: white;\n  border-color: #f0dddd;\n  animation: borderColorChange 2s infinite;\n}\n\n@keyframes borderColorChange {\n  0% {\n    border-color: #FF0000;\n  }\n  16.67% {\n    border-color: #FF6A00;\n  }\n  33.33% {\n    border-color: #FFD800;\n  }\n  50% {\n    border-color: #00FF00;\n  }\n  66.67% {\n    border-color: #0000FF;\n  }\n  83.33% {\n    border-color: #4B0082;\n  }\n  100% {\n    border-color: #9400D3;\n  }\n}\n\n.footer {\n  padding: 1rem 0;\n  width: 100%;\n  /* position: absolute; */\n  bottom: 0;\n}\n\n.footer-container {\n  display: flex;\n  justify-content: space-around;\n  width: 100%;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.footer-links {\n  display: flex;\n  align-items: center;\n}\n\n.footer-links a {\n  color: #f2f2f2;\n  text-decoration: none;\n  margin-right: 1rem;\n}\n\n.footer-links a:hover {\n  color: #e0e0e0;\n}\n\n/* Remove underline from footer & a href */\n.footer-links a:hover {\n  text-decoration: none;\n}\n\n.footer-copyright {\n  color: #f2f2f2;\n  font-size: 0.9rem;\n}\n\na {\n  color: white;\n}\n\na:hover {\n  color: #ff6600;\n}\n\n#team {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.section {\n  flex: 0 0 48%; /* Each section will take up 48% of the available space */\n  margin: 10px;\n  /* Add media query to stack sections vertically on smaller screens */\n}\n\n.discord-banner {\n  display: flex;\n  align-items: center;\n  background-color: #5865F2; /* Discord's blurple color from the color palette */\n  color: #fff;\n  padding: 5px;\n  border-radius: 5px;\n  margin-top: 10px;\n  width: fit-content;\n}\n\n.discord-icon {\n  font-size: 18px;\n  margin-right: 5px;\n}\n\n.discord-tag {\n  font-size: 14px;\n}\n\n.member {\n  /* width: calc(50% - 20px); */\n  margin: 10px;\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 5px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  position: relative;\n}\n\n.member img {\n  width: 150px;\n  border-radius: 50%;\n}\n\n.member h2 {\n  font-size: 24px;\n  margin-top: 10px;\n}\n\n.member p {\n  margin-top: 5px;\n}\n\n.member .social-links {\n  margin-top: 10px;\n}\n\n.member .social-links a {\n  color: #555;\n  text-decoration: none;\n  margin-right: 10px;\n  font-size: 18px;\n}\n\n.member .social-links a:hover {\n  color: #ff6600;\n}\n\n.countdown-box.svelte-1xheok0 {\n  min-width: 23em;\n  margin: 0 auto;\n  font-family: \"Dosis\", sans-serif;\n  background-color: #c13e05;\n  padding: 15px 10px;\n  text-align: center;\n  color: white;\n  font-size: 14pt;\n  border-radius: 20px;\n  box-shadow: 10px 10px 12px -15px black;\n}\n\n.countdown-box.svelte-1xheok0 {\n  width: auto; /* Adjust to content */\n  max-width: 550px;\n  margin: 20px auto; /* Center the box */\n  font-family: 'Dosis', sans-serif;\n  background-color: #c13e05; /* LTT orange */\n  padding: 15px 20px; /* Increased padding */\n  text-align: center;\n  color: white;\n  font-size: 14pt;\n  border-radius: 20px;\n  box-shadow: 10px 10px 12px -15px black;\n  white-space: nowrap; /* Prevents the text from wrapping */\n}\n\n.provider-text {\n  font-size: 10pt;\n  text-align: right;\n  color: #ffffff;\n}\n\n#wan-show-timer a {\n  text-decoration: none;\n  color: inherit;\n  display: block; /* Make the entire area clickable */\n}\n\n.discord-banner {\n  display: flex;\n  align-items: center;\n  background-color: #5865F2; /* Discord's blurple color from the color palette */\n  color: #fff;\n  padding: 5px;\n  border-radius: 5px;\n  margin-top: 10px;\n  width: fit-content;\n}\n\n.discord-icon {\n  font-size: 18px;\n  margin-right: 5px;\n}\n\n.discord-tag {\n  font-size: 14px;\n}\n\n.discord-tag {\n  background-color: #5865F2; /* Discord's purple color from the color palette */\n  padding: 5px 10px;\n  border-radius: 15px;\n  display: inline-block;\n}\n\n.discord-banner::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: calc(100% + 10px);\n  height: calc(100% + 10px);\n  border-radius: 20px;\n  z-index: -1;\n}\n\n.member {\n  margin-bottom: 20px;\n}\n\n.section h2 {\n  color: white;\n}\n\n@media (max-width: 768px) {\n  .section {\n    flex: 0 0 100%; /* On smaller screens, each section takes up 100% of the available space */\n  }\n}\n\n@media (max-width: 768px) {\n  .member {\n    width: calc(50% - 18px);\n  }\n}\n\n@media (max-width: 768px) {\n  .footer-container {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .footer-links {\n    margin-bottom: 0.5rem;\n  }\n}\n\n@media (max-width: 3840px) {\n  #game {\n    /* transform: scale(1.2); */  /* use the base scale ladder */ /* Scale down to 90% on smaller screens */\n    /* transform-origin: center; */  /* use the base scale ladder */ /* Added to scale from the center */\n  }\n\n  #nav-container {\n    transform: scale(0.8); /* Scale down to 80% on even smaller screens */\n    transform-origin: center; /* Added to scale from the center */\n  }\n}\n\n@media (max-width: 1920px) {\n  #game {\n    /* transform: scale(1.0); */  /* use the base scale ladder */ /* Scale down to 90% on smaller screens */\n    /* transform-origin: center; */  /* use the base scale ladder */ /* Added to scale from the center */\n    padding-left: 10px;\n  }\n\n  #nav-container {\n    transform: scale(1.0); /* Scale down to 80% on even smaller screens */\n    transform-origin: center; /* Added to scale from the center */\n  }\n}\n\n@media (max-width: 1200px) {\n  #game {\n    /* transform: scale(0.9); */  /* use the base scale ladder */ /* Scale down to 90% on smaller screens */\n    /* transform-origin: center; */  /* use the base scale ladder */ /* Added to scale from the center */\n    padding-left: 10px;\n  }\n\n  #nav-container {\n    transform: scale(0.9); /* Scale down to 80% on even smaller screens */\n    transform-origin: center; /* Added to scale from the center */\n  }\n}\n\n@media (max-width: 768px) {\n  #game {\n    /* transform: scale(0.84); */  /* use the base scale ladder */ /* Scale down to 80% on even smaller screens */\n    /* transform-origin: center; */  /* use the base scale ladder */ /* Added to scale from the center */\n    padding-left: 10px;\n  }\n\n  #nav-container {\n    transform: scale(0.84); /* Scale down to 80% on even smaller screens */\n    transform-origin: center; /* Added to scale from the center */\n  }\n}\n\n@media (max-width: 480px) {\n  #game {\n    /* transform: scale(0.65); */  /* use the base scale ladder */ /* Scale down to 70% on the smallest screens */\n    /* transform-origin: center; */  /* use the base scale ladder */ /* Added to scale from the center */\n    padding-left: 10px;\n  }\n\n  #nav-container {\n    transform: scale(0.65); /* Scale down to 80% on even smaller screens */\n    transform-origin: center; /* Added to scale from the center */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
